import { Stack, type StackProps } from "@mui/material";
import { omit } from "lodash-es";
import type { FC, ReactNode } from "react";

export const GreyBox: FC<StackProps & { children: ReactNode }> = ({ children, ...rest }) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ p: 2, backgroundColor: "background.contrast", ...(rest?.sx ?? {}) }}
      alignItems="center"
      justifyContent="center"
      {...omit(rest, ["sx"])}
    >
      {children}
    </Stack>
  );
};
